import { render, staticRenderFns } from "./BroadcastDetail.vue?vue&type=template&id=1285c78e&scoped=true"
import script from "./BroadcastDetail.vue?vue&type=script&lang=js"
export * from "./BroadcastDetail.vue?vue&type=script&lang=js"
import style0 from "./BroadcastDetail.vue?vue&type=style&index=0&id=1285c78e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1285c78e",
  null
  
)

export default component.exports